module.exports = require("core-js-pure/stable/number/parse-float");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js-stable/number/parse-float.js
// module id = 6466
// module chunks = 25